// extracted by mini-css-extract-plugin
export default {"hide":"styles_hide__-jyUW","greyed-out":"styles_greyed-out__CVu7b","sectionHeader":"styles_sectionHeader__jnffB","editButtons":"styles_editButtons__VjuYX"};